<template>
  <a-config-provider :locale="languageState.currentLocale">
    <div id="app">
      <router-view />
    </div>
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import enUS from 'ant-design-vue/lib/locale-provider/en_US'

// 从URL获取语言参数的函数
function getLanguageFromUrl() {
  const urlParams = new URLSearchParams(window.location.search)
  const lang = urlParams.get('lang')
  return lang === 'zh' ? 'zh' : 'en' // 默认英语
}

export default {
  name: 'App',
  data() {
    // 从URL获取语言参数
    const lang = getLanguageFromUrl()
    
    return {
      // 将语言状态包装在一个对象中，确保响应性
      languageState: {
        currentLanguage: lang, // 默认英语
        currentLocale: lang === 'en' ? enUS : zhCN
      }
    }
  },
  provide() {
    return {
      languageState: this.languageState,
      changeLanguage: this.changeLanguage
    }
  },
  methods: {
    changeLanguage(lang) {
      if (lang === 'en') {
        this.languageState.currentLocale = enUS
        this.languageState.currentLanguage = 'en'
      } else {
        this.languageState.currentLocale = zhCN
        this.languageState.currentLanguage = 'zh'
      }
    }
  }
}
</script>

<style>
/* 全局样式保持不变 */
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /* text-align: center; */
  color: #2c3e50;
}
</style>
